import { render, staticRenderFns } from "./InvestorOnboardingTaxProfile.vue?vue&type=template&id=65c6bad2&"
import script from "./InvestorOnboardingTaxProfile.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingTaxProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports